
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suggested",
      function () {
        return require("private-next-pages/suggested.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suggested"])
      });
    }
  